import React, { useState } from 'react';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const COLORS = {
  critical: '#b91c1c',
  major: '#e07b7b',
  minor: '#fbb8b8',
  line: '#7c3aed',
};

function BugsByDimensionChart({ data, dimensionKey }) {
  return (
    <div>
      <ResponsiveContainer width="100%" height={200}>
        <ComposedChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 50 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey={dimensionKey}
            tick={{ fontSize: 11 }}
            angle={-30}
            textAnchor="end"
            interval={0}
          />
          <YAxis yAxisId="left" />
          <YAxis yAxisId="right" orientation="right" hide />
          <Tooltip />
          <Legend verticalAlign="top" wrapperStyle={{ fontSize: 12 }} />
          <Bar yAxisId="left" dataKey="critical" stackId="bugs" fill={COLORS.critical} name="Bug Critical" />
          <Bar yAxisId="left" dataKey="major" stackId="bugs" fill={COLORS.major} name="Bug Major" />
          <Bar yAxisId="left" dataKey="minor" stackId="bugs" fill={COLORS.minor} name="Bug Minor" />
          <Line
            yAxisId="right"
            dataKey="total"
            type="monotone"
            stroke={COLORS.line}
            strokeWidth={2}
            dot={{ r: 3 }}
            name="Total"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}

const VIEWS = [
  { key: 'component', label: 'By Product Component', dimensionKey: 'component' },
  { key: 'unit', label: 'By Product Unit', dimensionKey: 'unit' },
];

function ConfirmedBugsSeverity({ byComponent, byUnit, noHeader }) {
  const [view, setView] = useState('component');
  const active = VIEWS.find(v => v.key === view);
  const data = view === 'component' ? byComponent : byUnit;

  return (
    <>
      {!noHeader && <div className="section-header">Confirmed Bugs with severity</div>}
      <div className="section-body" style={noHeader ? { border: 'none', padding: 0 } : {}}>

        <div style={{ display: 'flex', gap: 4, marginBottom: 16 }}>
          {VIEWS.map(v => (
            <button
              key={v.key}
              onClick={() => setView(v.key)}
              style={{
                padding: '4px 12px',
                fontSize: 12,
                borderRadius: 4,
                border: '1px solid var(--cmp-border)',
                cursor: 'pointer',
                background: view === v.key ? 'var(--cmp-primary)' : 'var(--cmp-card-bg)',
                color: view === v.key ? '#fff' : 'var(--cmp-text)',
                fontWeight: view === v.key ? 600 : 400,
              }}
            >
              {v.label}
            </button>
          ))}
        </div>

        <BugsByDimensionChart
          data={data}
          dimensionKey={active.dimensionKey}
        />

      </div>
    </>
  );
}

export default ConfirmedBugsSeverity;
